export const inspectionbasicconfig ={
    inspectorrole:{
        service:{
            name:'inspectorrole',
            title:'Inspector Role',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },
    teamrole:{
        service:{
            name:'teamrole',
            title:'Team Role',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    inspectortype:{
        service:{
            name:'inspectortype',
            title:'Inspector Type',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    inspectionstate:{
        service:{
            name:'inspectionstate',
            title:'Inspection State',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    violation:{
        service:{
            name:'violation',
            title:'Violation',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Short Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    severity:{
        service:{
            name:'severity',
            title:'Severity',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Short Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    inspectiontype:{
        service:{
            name:'inspectiontype',
            title:'Inspector Type',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    itemtype:{
        service:{
            name:'itemtype',
            title:'Item Type',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    itemstate:{
        service:{
            name:'itemstate',
            title:'Item State',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    findingstate:{
        service:{
            name:'findingstate',
            title:'Finding State',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },

    directivestate:{
        service:{
            name:'directivestate',
            title:'Directive State',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },
    declarationstate:{
        service:{
            name:'declarationstate',
            title:'Declaration State',
            key:'rid',
            num: false,
            fields: ['rid','nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
            params: {nam:'Service',shc:'Code',dsc:'Description',svc:'Service Code',sts:'Status'},
            grid: [['nam','Name'],['shc','Code'],['dsc','Description'],['sts','Status'],['stp','Stamp']],
            bar: {pag:true,btn:['add','edit','del','view']},
            menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
            eform:[{id:'nam',label:'Name',type:'tf',req:1,ops:{}},
                {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
                {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'svc',label:'Service Code',type:'nf',req:1,ops:{}},
                {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
                ],
        },
        create:true,
        actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
        panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'}
    },
}